// extracted by mini-css-extract-plugin
module.exports = {"videoPlayer":"src-components-Shards-VideoPlayer-Youtube-styles-style-module__videoPlayer--1dYe-"};